// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__1bbeZ","oh-rotating":"loader_oh-rotating__3cyH7"};